import { bridge } from '../../bridge';
import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../hooks/useRootNavigation';

type moveToMarketHomeProps = {
  sno: number;
  categorySno?: number | null;
  showCoupons?: boolean;
  order?: string | null;
};

export const useMoveToMarketHome = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation: any = useRootStackNavigation();

  const moveToMarketHome = useCallback(
    ({
      sno,
      categorySno = null,
      showCoupons = false,
      order = null,
    }: moveToMarketHomeProps) => {
      bridge.openDeeplink(
        `ably://react/App?package=market&screen=MarketHome&params=${sno}&extras=${JSON.stringify(
          { category_sno: categorySno, show_coupons: showCoupons, order },
        )}`,
        {
          webCallback: () => {
            navigation.navigate('MarketHome', {
              marketId: sno,
            });
          },
        },
      );
    },
    [navigation],
  );

  return {
    moveToMarketHome,
  };
};
